import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  DialogActions,
  FormControl,
  FormGroup,
  Grid,
  TextField,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Search from "@material-ui/icons/Search";
import Send from "@material-ui/icons/Send";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { mapActionsToProps } from "../../redux/sms/sms";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  add: {
    marginLeft: theme.spacing.unit * 3,
  },
});

class SMS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: "",
      to: "",
      content: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      openModalSchedule: false,
      openDialogSendFile: false,
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
  }

  listCollumns = [
    { id: "loaisms", numeric: true, disablePadding: false, label: "Loại SMS" },
    { id: "from", numeric: true, disablePadding: false, label: "Gửi từ" },
    { id: "to", numeric: true, disablePadding: false, label: "Người nhận" },
    { id: "content", numeric: true, disablePadding: false, label: "Nội dung" },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "from":
            case "to":
            default: {
              // if (key.startsWith("from") || key.startsWith("to")) {
              //     if (key == "from") {
              //         and.push({ time: { gte: this.state.filters.where.from } });
              //         where.and = and;
              //     } else {
              //         and.push({ time: { lte: this.state.filters.where.to } });
              //         where.and = and;
              //     }
              // } else {
              where[key] = element;
              // }
              break;
            }
          }
        }
      }
    }

    if (this.props.user) {
      if (this.props.user.username == "admin") {
        return (
          this.props.getListSMS(filters.order, filters.pageSize, filters.page, {
            where,
          }),
          this.props.countListSms({ where: where })
        );
      } else
        return (
          this.props.getListSMS(filters.order, filters.pageSize, filters.page, {
            where: { from: "CMC Telecom" },
          }),
          this.props.countListSms({ where: { from: "CMC Telecom" } })
        );
    }
  }

  handleChange = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeContent = () => {
    return (e) => {
      this.setState({
        content: e.target.value,
        length: e.target.value.length,
      });
    };
  };

  handleSendSMS = () => {
    const { from, to, content, data } = this.state;
    // const multiTo = this.state.to.split(';');
    // multiTo.forEach(to => {
    //     data.push({ from, to, content })
    // });
    // this.props.sendSMS(data)
    this.props.sendSMS(from, to, content);
    setTimeout(
      function () {
        this.setState({ modalSend: false });
      }.bind(this),
      500
    );
    this.itemInit();
  };

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  closeModalSend = () => {
    this.setState({
      modalSend: false,
      openModalSchedule: false,
      openDialogSendFile: false,
    });
  };

  handleEdit = (item) => {
    this.state.item = item;
    this.setState({ modalEdit: true });
  };

  closeModalDelete = () => {
    this.setState({ modalEdit: false });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD HH:mm:ss");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD HH:mm:ss");
    this.setState({ to });
  };
  openModalSchedule = () => {
    this.setState({ openModalSchedule: true });
  };
  openDialogSendFile = () => {
    this.setState({ openDialogSendFile: true });
  };
  render() {
    const { classes, listSMS, countSMS } = this.props;
    const { from, to, content, filters, item } = this.state;
    const listSMSResult =
      typeof listSMS === "object"
        ? Object.keys(listSMS).map((key) => listSMS[key])
        : listSMS;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          // onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <Grid container spacing={24}>
                    <Grid item xs={4}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Người gửi"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.froms}
                        name="froms"
                        validators={["required"]}
                        errorMessages={[`Không được để trống`]}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Người nhận"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.tos}
                        validators={["required"]}
                        errorMessages={[`Không được để trống`]}
                        name="tos"
                      />
                    </Grid>
                  </Grid>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item xs={4}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.from}
                          maxDate={new Date()}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="from"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.to}
                          maxDate={this.state.date}
                          minDate={filters.where.from}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="to"
                        />
                      </Grid>

                      <Grid item xs={4}>
                        <Fab
                          color="secondary"
                          aria-label="Search"
                          className={classes.fab}
                          onClick={this.handleSubmit}>
                          <Search />
                        </Fab>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách SMS"
          items={listSMSResult}
          rowsPerPage={filters.pageSize}
          count={countSMS ? countSMS.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          allowEdit={true}
          handleEdit={this.handleEdit}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            <div style={{ display: "flex" }}>
              <Fab
                variant="extended"
                color="secondary"
                aria-label="send"
                className={classes.fab}
                onClick={this.openDialogSendFile}>
                Gửi theo file
                <Send className={classes.add} />
              </Fab>
              <Fab
                variant="extended"
                color="secondary"
                aria-label="send"
                className={classes.fab}
                onClick={this.openDialogCreate}>
                Gửi nhanh
                <Send className={classes.add} />
              </Fab>
            </div>
          }
        />
        <Dialog
          open={this.state.modalSend}
          onClose={this.closeModalSend}
          title="Gửi tin nhắn"
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleSendSMS}
              onError={(errors) => console.log(errors)}>
              <TextValidator
                variant="outlined"
                className={classes.input}
                label="Người gửi"
                onChange={this.handleChange("from")}
                name="from"
                value={from}
                fullWidth
                validators={["required"]}
                errorMessages={[`Không được để trống`]}
              />
              <TextValidator
                variant="outlined"
                className={classes.input}
                label="Người nhận"
                onChange={this.handleChange("to")}
                name="to"
                value={to}
                fullWidth
                validators={["required", "minNumber: 0"]}
                errorMessages={[
                  `Không được để trống`,
                  "Please check phonenumber again!",
                ]}
              />
              <TextValidator
                variant="outlined"
                className={classes.input}
                label={`Nội dung - Độ dài tin nhắn: ${this.state.length}`}
                onChange={this.handleChangeContent("content")}
                name="content"
                multiline
                rows="15"
                value={content}
                fullWidth
                validators={["required"]}
                errorMessages={[`Không được để trống`]}
              />

              <DialogActions>
                <Button
                  onClick={this.closeModalSend}
                  color="primary"
                  variant="contained">
                  Hủy{" "}
                </Button>
                <Button type="submit" color="secondary" variant="contained">
                  Gửi
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
        />
        <Dialog
          open={this.state.openDialogSendFile}
          onClose={this.closeModalSend}
          title="Gửi tin nhắn theo file"
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.openDialogSendFile}
              onError={(errors) => console.log(errors)}>
              <TextValidator
                variant="outlined"
                className={classes.input}
                label="Thêm tệp"
                onChange={this.handleChange("protocol")}
                name="protocol"
                type="file"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                validators={["required"]}
                errorMessages={[`Không được để trống`]}
              />
              {this.state.openModalSchedule == true ? (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container spacing={24}>
                    <Grid item xs={6}>
                      <InlineDatePicker
                        margin="normal"
                        label="Thời gian bắt đầu"
                        variant="outlined"
                        className={classes.input}
                        maxDate={new Date()}
                        format="dd-MM-yyyy"
                        onChange={this.handleDateChangeStart}
                        name="from"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InlineDatePicker
                        margin="normal"
                        label="Thời gian kết thúc"
                        variant="outlined"
                        className={classes.input}
                        format="dd-MM-yyyy"
                        onChange={this.handleDateChangeEnd}
                        name="to"
                      />
                    </Grid>
                  </Grid>
                </MuiPickersUtilsProvider>
              ) : null}
              <DialogActions>
                <Button
                  onClick={this.closeModalSend}
                  color="primary"
                  variant="contained">
                  Hủy{" "}
                </Button>
                <Button type="submit" color="secondary" variant="contained">
                  Gửi
                </Button>
                <Button
                  onClick={this.openModalSchedule}
                  color="primary"
                  variant="contained">
                  Đặt lịch gửi tin{" "}
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
        />
        <Dialog
          open={this.state.modalEdit}
          title={"Thông tin"}
          input={
            this.state.item ? (
              <FormControl className={classes.form}>
                <FormGroup>
                  <Grid container spacing={24}>
                    <Grid item md={6}>
                      <TextField
                        className={classes.input}
                        label="Người gửi"
                        name="from"
                        value={item.from}
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                      <TextField
                        className={classes.input}
                        label="Người gửi"
                        name="from"
                        value={datetimeHelper.toFormat(
                          item.createdAt,
                          "YYYY-MM-DD HH:mm:ss"
                        )}
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                    </Grid>
                    <Grid item md={6}>
                      <TextField
                        className={classes.input}
                        label="Người nhận"
                        name="to"
                        value={item.to}
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                      <TextField
                        className={classes.input}
                        label="User"
                        name="user"
                        value={item.createdBy.userId}
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={24}>
                    <Grid item md={12}>
                      <TextField
                        className={classes.input}
                        label="Content"
                        name="content"
                        variant="outlined"
                        value={item.content}
                        fullWidth
                        multiline
                        rows={3}
                        disabled
                      />
                    </Grid>
                  </Grid>
                </FormGroup>
              </FormControl>
            ) : null
          }
          exit={true}
          onClose={this.closeModalDelete}
        />
      </React.Fragment>
    );
  }
}

SMS.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listSMS: state.sms.listSms,
  countSMS: state.sms.count,
  user: state.user.users,
});

SMS = connect(mapStateToProps, mapActionsToProps)(SMS);

export default withStyles(styles)(SMS);
